import { Person } from '@mui/icons-material';
import { Grid, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  GenContextualMenu,
  UserAvatar,
} from '@pinnacleautomotive/clarity-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import LogOut from '../../hooks/LogOut';
import { openProfileManagerDialog } from '../../redux/actions/userManagementActions';
import { selectUserPerson } from '../../redux/selectors/userDataSelectors';
import AppProfileManager from './AppProfileManager';

const PREFIX = 'AppMenuAvatar';

const classes = {
  container: `${PREFIX}-container`,
  userMainInfo: `${PREFIX}-userMainInfo`,
};

const StyledGrid = styled(Grid, {
  shouldForwardProp: prop => prop !== 'isTemporary',
})(({ theme, isTemporary }) => ({
  [`&.${classes.container}`]: {
    padding: theme.spacing(1, 1, 1, 3),
    marginBottom: theme.spacing(2),
    '&:hover': {
      backgroundColor: theme.palette.grey[800],
    },
    [theme.breakpoints.only('lg')]: {
      paddingLeft: isTemporary ? '' : '10px',
    },
  },

  [`& .${classes.userMainInfo}`]: {
    maxWidth: '103px',
    [theme.breakpoints.only('lg')]: {
      display: isTemporary ? '' : 'none',
    },
  },
}));

const AppMenuAvatar = ({ isTemporary }) => {
  const { t } = useTranslation('global');
  const dispatch = useDispatch();
  const person = useSelector(selectUserPerson);

  const openProfileManager = () => {
    dispatch(openProfileManagerDialog());
  };

  const popMenuComponents = [
    {
      name: t('menuAvatar.menu.profile'),
      icon: <Person />,
      onClick: openProfileManager,
    },
    { icon: <LogOut /> },
  ];

  return (
    <>
      <AppProfileManager />
      <StyledGrid
        container
        className={classes.container}
        isTemporary={isTemporary}
      >
        <Grid item>
          <Box mr={2}>
            <UserAvatar
              photo={person.photo}
              firstName={person.firstName}
              lastName={person.lastName}
            />
          </Box>
        </Grid>
        <Grid item>
          <Box className={classes.userMainInfo}>
            <Typography variant="body1" color="white">
              {[person.firstName, person.lastName].filter(x => x).join(' ')}
            </Typography>
            <Typography variant="body2" color="gray">
              {person.title}
            </Typography>
          </Box>
        </Grid>
        <Grid item>
          <GenContextualMenu
            options={popMenuComponents}
            buttonId="avatar-menu-button"
            menuId="mainMenuKebabMenu"
            anchorPosition={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            iconColor="white"
          />
        </Grid>
      </StyledGrid>
    </>
  );
};

export default AppMenuAvatar;
